// @flow

export function formatExpiryDate(expiryDateString: string): string {
  const expiryDateParts = expiryDateString.split('/');

  const month = parseInt(expiryDateParts[0], 10);

  const year = (expiryDateParts[1].length === 2)
    ? parseInt('20' + expiryDateParts[1], 10)
    : parseInt(expiryDateParts[1], 10);

  return `${month}/${year}`;
}
